import styled from 'styled-components';

import getBgColorByType from '@r1-frontend/ui-react/components/buttons/button/getBgColorByType';
import getHoveringBgColorByType from '@r1-frontend/ui-react/components/buttons/button/getHoveringBgColorByType';
import getPaddingBySize from '@r1-frontend/ui-react/components/buttons/button/getPaddingBySize';
import getScaleValueBySize from '@r1-frontend/ui-react/components/buttons/button/getScaleValueBySize';
import getTextColorByType from '@r1-frontend/ui-react/components/buttons/button/getTextColorByType';
import { TButtonSize, TButtonType } from '@r1-frontend/ui-react/components/buttons/button/index';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export type TStyledButtonProps = {
    bType: TButtonType,
    size: TButtonSize,
    rounded: boolean,
    hasIcon: boolean,
    animation: boolean,
};

export const StyledButton = styled.button<TStyledButtonProps>`
    position: relative;
    background-color: ${({ bType }) => getBgColorByType(bType)};

    border: none;
    border-radius: ${({ rounded = false }) => rounded ? '50%' : '30px'};

    box-sizing: border-box;
    box-shadow: none;

    color: ${({ bType }) => getTextColorByType(bType)};
    cursor: pointer;

    padding: ${({ size, hasIcon, rounded = false }) => getPaddingBySize(size, hasIcon, rounded)};

    ${({ animation }) => animation ? 'transition: transform .2s;' : ''}

    ${({ size }) => size === 'small' ? FONTS.MediumXS : FONTS.MediumS};

    &:active {
        ${({ size, animation }) => animation ? `transform: scale(${getScaleValueBySize(size)});` : ''}
    }

    &[disabled] {
        background-color: ${COLORS.GRAY_LIGHT};
        color: ${COLORS.TextHint};
        cursor: none;

        pointer-events: none;
    }

    @media (hover: hover) {
        :hover {
            background-color: ${({ bType }) => getHoveringBgColorByType(bType)};
        }
     }

    ${Svg} {
        & #guts {
            ${({ bType }) => bType === 'action' || bType === 'primary' ? `stroke: ${COLORS.TextWhite};` : ''}
        }
    }
`;

export const StyledThrobber = styled(Throbber)`
    div {
        width: 15px;
        height: 15px;
        margin-top: 4px;
        margin-bottom: 4px;
    }
`;

export const Wrapper = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    gap: 8px;

    white-space: nowrap;
`;
